import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import sqTranslation from "./assets/languages/sq.json";
import enTranslation from "./assets/languages/en.json";
import {parseLanguageLocaleString} from "./utils/utils";

const lng = parseLanguageLocaleString(localStorage.getItem("language"));

if (localStorage.getItem("language") !== lng) {
  localStorage.setItem("language", lng);
}

i18n.use(initReactI18next).init({
  resources: {
    sq: { translation: sqTranslation },
    en: { translation: enTranslation },
  },
  lng: lng,
  fallbackLng: "sq",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
